query AnalyticsSalesByCountry($filter: AnalyticsSalesFilterInput!, $limit: Int) {
  analyticsSales(filter: $filter) {
    currency
    salesByCountry(limit: $limit) {
      countryCode
      sales
      revenue
    }
  }
}
